/** @format */

import { isMobile } from '@power/utils';

import { PcMoModal } from '@/components/mobile/pc-mo-modal';
import { PcModal } from '@/components/pc-modal';
export function initPData() {
	if (!window.pData) {
		window.pData = {};
	}
	const utils = {
		modal: isMobile() ? PcMoModal : PcModal,
	};
	if (!window.pData.utils) {
		window.pData.utils = utils;
	} else {
		window.pData.utils = Object.assign({}, window.pData.utils, utils);
	}
}
